import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import documentFiltersSignal, {
	setDocumentFilters,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/Signals/documentFiltersSignal';
import dossierPeriodOptions, {
	type DossierPeriod,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/Helpers/dossierPeriodOptions';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

/** Rolling period preset written through to the signal immediately. */
const DocumentPeriodFilter: React.FC = () => {
	const currentFilters = useSignalValue(documentFiltersSignal);

	const handlePeriodChange = React.useCallback((period: DossierPeriod | null) => {
		if (period === null) {
			return;
		}

		setDocumentFilters(documentFiltersSignal.peek().setPeriod(period));
	}, []);

	return (
		<Dropdown<DossierPeriod>
			name="documentPeriod"
			label="Période"
			isLabelHidden
			options={[...dossierPeriodOptions]}
			optionLabel="label"
			optionValue="value"
			value={currentFilters.period}
			onChange={handlePeriodChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default DocumentPeriodFilter;
